// extracted by mini-css-extract-plugin
export default {"home":"style_home__Zdv4I","banner":"style_banner__k2RHP","row":"style_row__dVS5e","grid":"style_grid__LY1W0","slidContent":"style_slidContent__W4Pvz","btnRow":"style_btnRow__kv1xc"};